import { getApiErrorMessage } from './api'

export function openPdfBlobInNewTab(blob) {
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank', 'noopener,noreferrer')
  setTimeout(() => {
    try { URL.revokeObjectURL(url) } catch { /* ignore */ }
  }, 120000)
}

async function readBlobErrorMessage(blob, fallback) {
  if (!blob || typeof blob.text !== 'function') return fallback
  try {
    const text = (await blob.text()).trim()
    if (text.startsWith('{')) {
      const parsed = JSON.parse(text)
      if (parsed?.message) return parsed.message
    }
    if (text) return text
  } catch { /* ignore */ }
  return fallback
}

export async function openCounselSurveyReportPdf(api, sessionId) {
  if (!sessionId) return
  try {
    const res = await api.get(`/counsel-surveys/reports/${sessionId}/pdf`, { responseType: 'blob' })
    const contentType = String(res.headers?.['content-type'] || '')
    if (contentType.includes('application/json')) {
      const message = await readBlobErrorMessage(res.data, '상담 리포트 PDF를 불러오지 못했습니다.')
      throw new Error(message)
    }
    openPdfBlobInNewTab(new Blob([res.data], { type: 'application/pdf' }))
  } catch (e) {
    const blob = e?.response?.data
    if (blob && typeof blob.text === 'function') {
      const message = await readBlobErrorMessage(blob, getApiErrorMessage(e, '상담 리포트 PDF를 불러오지 못했습니다.'))
      throw new Error(message)
    }
    throw e
  }
}
